import {
  Menu,
  MenuItem,
  AppBar,
  Box,
  Button,
  Drawer,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
//import { Menu, MenuItem, AppBar, Box, Button,  IconButton, Toolbar, Typography } from "@mui/material";

import { NavLink } from "react-router-dom";
import React, { useState } from "react";
import NavListDrawer from "./NavListDrawer";
import Hidden from "@mui/material/Hidden";

//iconos
import FaceIcon from "@mui/icons-material/Face6";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import AssignmentIcon from "@mui/icons-material/Assignment";
import InventoryIcon from "@mui/icons-material/Inventory";
import BuildIcon from "@mui/icons-material/Build";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import EmailIcon from "@mui/icons-material/Email";
//import BugReportIcon from "@mui/icons-material/BugReport";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import ShutterSpeedIcon from "@mui/icons-material/ShutterSpeed";

const Navbar = ({ loggedIn }) => {
  // Bodega
  //import Monitor from './pages/bodega/Monitor';
  //import Inventario from './pages/bodega/Inventario';
  //import Despachos from './pages/bodega/Despachos';
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCustomVar = (value) => {
    setOpen(!value);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // const navArrayLinks = [
  //   { bloqueo:true , title : 'Dashboard', path: '/dashboard', icon: <DashboardIcon/> },
  //   { bloqueo:true , title : 'Monitor', path: '/monitor', icon: <LaptopWindowsIcon/> },
  //   { bloqueo:true , title : 'Logout', path: '/logout', icon: <LogoutIcon/> },
  //   { bloqueo:false, title : 'Login', path: '/', icon: <FaceIcon/>},
  // ];

  // Para ver la PC pantallas grandes
  const navArrayLinksPC = [
    {
      bloqueo: true,
      title: "Dashboard",
      path: "/dashboard",
      icon: <DashboardIcon sx={{ color: "black" }} />,
    },
    {
      bloqueo: true,
      title: "Bodega",
      path: "/bodega",
      icon: <AssignmentIcon sx={{ color: "black" }} />,
      submenu: [
        {
          bloqueo: true,
          title: "Inventario",
          path: "/inventario",
          icon: <InventoryIcon fontSize="small" sx={{ color: "green" }} />,
        },
        {
          bloqueo: true,
          title: "Correo Despacho",
          path: "/despachoscorreopda",
          icon: <EmailIcon fontSize="small" sx={{ color: "green" }} />,
        },
      ],
    },
    // {
    //   bloqueo: true,
    //   title: "Prueba",
    //   path: "/pruebas",
    //   icon: <BugReportIcon sx={{ color: "black" }} />,
    // },
    {
      bloqueo: true,
      title: "Logout",
      path: "/logout",
      icon: <LogoutIcon sx={{ color: "black" }} />,
    },
    {
      bloqueo: false,
      title: "Login",
      path: "/",
      icon: <FaceIcon sx={{ color: "black" }} />,
    },
  ];

  // Para ver la PC pantallas pequeñas sm y xs
  const navArrayLinksApp = [
    {
      bloqueo: true,
      title: "Dashboard",
      path: "/dashboard",
      icon: <DashboardIcon sx={{ color: "black" }} />,
    },
    {
      bloqueo: true,
      title: "Flota",
      path: "/flota",
      icon: <SettingsSuggestIcon sx={{ color: "black" }} />,
      submenu: [
        {
          bloqueo: false,
          title: "Bitacora",
          path: "/bitacoras",
          icon: <ShutterSpeedIcon fontSize="small" sx={{ color: "green" }} />,
        },
      ],
    },
    {
      bloqueo: true,
      title: "Bodega",
      path: "/bodega",
      icon: <AssignmentIcon sx={{ color: "black" }} />,
      submenu: [
        {
          bloqueo: true,
          title: "Producto",
          path: "/productopda",
          icon: <BuildIcon fontSize="small" sx={{ color: "green" }} />,
        },
        {
          bloqueo: true,
          title: "Inventario",
          path: "/inventariopda",
          icon: <InventoryIcon fontSize="small" sx={{ color: "green" }} />,
        },
        {
          bloqueo: true,
          title: "Preparación",
          path: "/preparacionpda",
          icon: <BuildIcon fontSize="small" sx={{ color: "green" }} />,
        },
        {
          bloqueo: true,
          title: "Despachos",
          path: "/despachospda",
          icon: <LocalShippingIcon fontSize="small" sx={{ color: "green" }} />,
        },
        {
          bloqueo: true,
          title: "Correo Despacho",
          path: "/despachoscorreopda",
          icon: <EmailIcon fontSize="small" sx={{ color: "green" }} />,
        },
        // {
        //   bloqueo: true,
        //   title: "Entrega",
        //   path: "/entregapda",
        //   icon: <HandshakeIcon fontSize="small" sx={{ color: "green" }} />,
        // },
      ],
    },
    // {
    //   bloqueo: true,
    //   title: "Prueba",
    //   path: "/pruebas",
    //   icon: <BugReportIcon sx={{ color: "black" }} />,
    // },
    {
      bloqueo: true,
      title: "Logout",
      path: "/logout",
      icon: <LogoutIcon sx={{ color: "black" }} />,
    },
    { bloqueo: false, title: "Login", path: "/", icon: <FaceIcon /> },
  ];

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            color="inherit"
            size="large"
            onClick={() => setOpen(true)}
            sx={{ display: { xs: "flex", sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Gandara Chile S.A.
          </Typography>
          <Box sx={{ display: { xs: "none", sm: "flex" } }}>
            {navArrayLinksPC.map((item) =>
              loggedIn ? (
                item.bloqueo === true ? (
                  item.submenu ? (
                    <Button
                      color="inherit"
                      key={item.title}
                      aria-controls={`${item.title.toLowerCase()}-menu`}
                      aria-haspopup="true"
                      onClick={handleMenuOpen}
                    >
                      {item.title}
                    </Button>
                  ) : (
                    <Button
                      color="inherit"
                      key={item.title}
                      component={NavLink}
                      to={item.path}
                    >
                      {item.title}
                    </Button>
                  )
                ) : null
              ) : !loggedIn && item.bloqueo === false ? (
                <Button
                  color="inherit"
                  key={item.title}
                  component={NavLink}
                  to={item.path}
                >
                  {item.title}
                </Button>
              ) : null
            )}
            <Menu
              id="bodega-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              {navArrayLinksPC
                .find((item) => item.title === "Bodega")
                ?.submenu.map((submenuItem) => (
                  <MenuItem
                    key={submenuItem.title}
                    component={NavLink}
                    to={submenuItem.path}
                    onClick={handleMenuClose}
                  >
                    {submenuItem.title}
                  </MenuItem>
                ))}
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      {/* Esto solo lo muestra cuando es pantalla pequeña  */}
      <Hidden smUp>
        <Drawer
          open={open}
          anchor="left"
          onClick={() => setOpen(false)}
          sx={{ display: { xs: "flex", sm: "none" } }}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <NavListDrawer
              navArrayLinks={navArrayLinksApp}
              loggedIn={loggedIn}
              handleCustomVar={handleCustomVar}
            />
          </div>
        </Drawer>
      </Hidden>
    </>
  );
};

export default Navbar;
